import type { ModuleWithProviders } from '@angular/core';
import { Inject, NgModule } from '@angular/core';

import { LOCALE } from '@core/i18n-legacy';

import {
  STRIPE_OPTIONS,
  STRIPE_PUBLISHABLE_KEY_BV,
  STRIPE_PUBLISHABLE_KEY_GMBH,
  STRIPE_PUBLISHABLE_KEY_INC,
  STRIPE_PUBLISHABLE_KEY_SAS,
} from './stripe-token';
import { StripeService } from './stripe.service';

export const stripeOptionsFactory = (locale: string) => ({
  locale,
});

@NgModule()
export class StripeModule {
  public static forRoot(
    publishableKeyBv: string,
    publishableKeyGmbh: string,
    publishableKeyInc: string,
    publishableKeySas: string,
  ): ModuleWithProviders<StripeModule> {
    return {
      ngModule: StripeModule,
      providers: [
        StripeService,
        {
          provide: STRIPE_PUBLISHABLE_KEY_BV,
          useValue: publishableKeyBv,
        },
        {
          provide: STRIPE_PUBLISHABLE_KEY_GMBH,
          useValue: publishableKeyGmbh,
        },
        {
          provide: STRIPE_PUBLISHABLE_KEY_INC,
          useValue: publishableKeyInc,
        },
        {
          provide: STRIPE_PUBLISHABLE_KEY_SAS,
          useValue: publishableKeySas,
        },
        {
          provide: STRIPE_OPTIONS,
          useFactory: stripeOptionsFactory,
          deps: [[new Inject(LOCALE)]],
        },
      ],
    };
  }
}
